<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Documents</div>
                <button type="submit" v-on:click.prevent="addManagerToolBox" class="btn btn-primary waves-effect pull-right">Add</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <div class="row form-group">
                        <div class="col-sm-12 col-md-4 serch-event-tab">
                            <input v-on:keyup.enter="searchCall()" type="text" class="form-control" id="searchManagerToolBox" placeholder="Search" v-model="searchManagerToolBox" name="searchManagerToolBox" />
                        </div>
                        <div class="input-group-prepend border-0">
                            <button v-on:click.prevent="searchCall()" style="height: 45px;" id="button-addon4" type="button" class="btn btn-primary"><i class="fa fa-search"></i></button> 
                            <button v-on:click.prevent="clearSearch()" style="margin-left: 10px; height: 45px;" id="button-clear" type="button" class="btn btn-danger"><i class="fa fa-times"></i></button>
                        </div> 
                        <div class="col-md-6">
                            <v-select class="input-field-si" v-model="sortManagerToolBox" 
                                name="sortManagerToolBox" 
                                placeholder="Select field for sorting"
                                label="text"
                                :options="sortManagerToolBoxArr"
                                :clearable=false>
                            </v-select>
                        </div>
                        <div class="mt-10 col-6 forms-block">
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="folderId"
                                                  @change="changedValue"
                                                  @input="changeFolder()"
                                                  name="folderId"
                                                  id="folderData"
                                                  label="name"
                                                  :filterable="false"
                                                  :clearable="false"
                                                  :options="reportToArr"
                                                  @search="onSearchFolder"
                                                  placeholder="Select Folder">
                                            <template slot="no-options">
                                                Search Folder...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{folderError}}</font>
                                </div>
                            </div>
                    </div>
                    <div v-if="(managerToolBoxArr && (managerToolBoxArr.toolBoxData && managerToolBoxArr.toolBoxData.length > 0))" class="internal-listing-container">
                        <template v-for="(managerToolBox, index) in managerToolBoxArr.toolBoxData">
                            <div v-bind:key="index" class="single-listing">
                                <div class="upload-doc-img">
                                    <template v-if="managerToolBox.doc_extension.toLowerCase() == 'gif'">
                                        <img src="/static/images/link-icon.png">
                                    </template>
                                    <template v-else-if="managerToolBox.doc_extension.toLowerCase() == 'doc' || managerToolBox.doc_extension.toLowerCase() == 'docx'">
                                        <img src="/static/images/doc-icon.png">
                                    </template>
                                    <template v-else-if="managerToolBox.doc_extension.toLowerCase() == 'xls' || managerToolBox.doc_extension.toLowerCase() == 'xlsx'">
                                        <img src="/static/images/xl-icon.png">
                                    </template>
                                    <template v-else-if="managerToolBox.doc_extension.toLowerCase() == 'ppt' || managerToolBox.doc_extension.toLowerCase() == 'pptx'">
                                        <img src="/static/images/ppt-icon.png">
                                    </template>
                                    <template v-else-if="managerToolBox.doc_extension.toLowerCase() == 'pdf'">
                                        <img src="/static/images/pdf-icon.png">
                                    </template>
                                    <template v-else>
                                        <img src="/static/images/link-icon.png">
                                    </template>
                                </div>
                                <div class="single-listing-text">
                                    <span v-b-tooltip.hover :title="managerToolBox.title">{{stringTrim(managerToolBox.title,60)}}</span>
                                </div>
                                <div class="download">
                                    <!-- <a :href="managerToolBox.document" class="downloadnow" target="_blank">Download Now!</a> -->
                                    <a href="#" :id="'id' + index" @click="getSignedUrlPath(managerToolBox.document)" class="downloadnow">Download Now!</a>
                                </div>
                                <div class="listing-user-info1">
                                    <div class="user-details">
                                        <div class="listing-user">{{managerToolBox.updated_name}}</div>
                                        <div class="listing-block-info">
                                            <div class="listing-date">{{managerToolBox.updated_date}}</div>
                                            <div class="listing-time">{{managerToolBox.updated_time}}</div>
                                        </div>
                                    </div>
                                    <b-navbar>
                                        <b-navbar-nav>
                                            <b-nav-item-dropdown>
                                                <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'UpdateManagerToolBox', params:{id: managerToolBox.id}}">Edit</router-link>
                                                <button class="btn btn-primary pull-right" v-on:click.prevent="deleteManagerToolBox(managerToolBox.id)">Delete</button>
                                            </b-nav-item-dropdown>
                                        </b-navbar-nav>
                                    </b-navbar>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-else class="internal-listing-container" style="text-align: center;">
                        Data Not Available
                    </div>
                    <div v-if="managerToolBoxArr.total_rows >= managerToolBoxArr.per_page">
                        <b-pagination align="center" prev-text="‹ Previous" next-text="Next ›" :total-rows="managerToolBoxArr.total_rows" v-model="currentPage" :per-page="managerToolBoxArr.per_page"></b-pagination>
                    </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import VueSweetalert2 from 'vue-sweetalert2';
    Vue.use(VueSweetalert2);
    var self;
    export default {
        name: 'ListManagerToolBox',
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                editFolderId: 0,
                folderId: 0,
                folderError: '',
                reportToArr: [],
                managerToolBoxArr: [],
                currentPage: 1,
                searchManagerToolBox: '',
                sortManagerToolBox: {text: 'Newest First', value: 'desc'},
                sortManagerToolBoxArr: [
                    {
                        text: 'Newest First',
                        value: 'desc'
                    },
                    {
                        text: 'Oldest First',
                        value: 'asc'
                    }
                ],
            }
        },
        watch: {
            currentPage: function() {
                self.loadManagetToolBox();
            },
            sortManagerToolBox: function() {
                if(self.folderId.id != 0){
                    self.getDocumentsByFolderID(self.folderId.id);
                }else{
                    self.loadManagetToolBox();
                }
            },
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
            var path = window.location.pathname;
            if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                self.getDocumentsByFolderID(self.$route.params.id);
                self.editFolderId = self.$route.params.id;
            }
            else{
                self.loadManagetToolBox();
            }
            self.loadFolders();
        },
        methods: {
            onSearchFolder(search, loading) {
                let self = this;
                /*if (self.siteid != null && self.siteid != "") {*/
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    self.loadFolders(loading, search, this);
                }
                /*}*/
            },
            changedValue: function (value) {
                // console.log(value);
            },
            changeFolder: function () {
                console.log(self.folderId);
                console.log(self.folderId.id);
                if(self.folderId !== 0){
                    self.getDocumentsByFolderID(self.folderId.id);
                }
                if(self.folderId.name === 'All'){
                    this.loadManagetToolBox();
                }
                
                self.folderError = "";
            },
            searchCall() {
                self.currentPage = 1;
                if(self.folderId.id != 0){
                    self.getDocumentsByFolderID(self.folderId.id);
                }else{
                    self.loadManagetToolBox();
                }
            },
            clearSearch() {
                self.currentPage = 1;
                self.searchManagerToolBox = '';
                // self.loadManagetToolBox();//Fixed on search it gives list of all documents
                if(self.folderId.id != 0){
                    self.getDocumentsByFolderID(self.folderId.id);
                }else{
                    self.loadManagetToolBox();
                }
            },
            addManagerToolBox() {
                self.$router.push('/backend/addmanagertoolbox');
            },
            deleteManagerToolBox: function(id) {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    data: {
                        'deleteId': id,
                    }
                };
                self.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("/managertoolbox/delete", config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.loadManagetToolBox();
                                }
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            });
                    }
                });
            },
            loadManagetToolBox: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'page': self.currentPage,
                        'filter': self.searchManagerToolBox,
                        'sort': self.sortManagerToolBox.value,
                    }
                };
                self.showLoader();
                HTTP.get("/managertoolbox/list", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                
                                self.managerToolBoxArr = response.data.content;
                                if (response.data.content.length <= 0) {
                                    self.currentPage = 1;
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            getDocumentsByFolderID: function (id) {
                if(id == 0){
                    return false;
                }
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'id':id,
                        'page': self.currentPage,
                        'filter': self.searchManagerToolBox,
                        'sort': self.sortManagerToolBox.value,
                    }
                };
                self.showLoader();
                HTTP.get("/get/docs", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.managerToolBoxArr = response.data.content;
                                if (response.data.content.length <= 0) {
                                    self.currentPage = 1;
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadFolders(loading, search, vm) {
                let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: search,
                    }
                };
                /* var fields = {
                    search: search,
                    except_self : 1,
                }; */
                HTTP.get("getfolder", config)
                        .then(function (response) {
                            self.reportToArr = [];
                            self.reportToArr.push(
                                {
                                    id: 0,
                                    name: 'All',
                                    text: 'All'
                                }
                            )
                            $.each(response.data.content, function (i) {
                                self.reportToArr.push(response.data.content[i]);
                            });
                            self.folderId = self.reportToArr.find(o => o.id == self.editFolderId);
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                // redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/backend/ManagerToolBox/ListManagerToolBox.vue